/**
 * @desc 查找指定门店
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** lat */
  lat: string;
  /** lng */
  lng: string;
  /** storeCodes */
  storeCodes: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.GeneralHttpResponse<Array<defs.store.SimpleStoreVO>>
  >(`/storeapi/api/v1/designated/store`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.SimpleStoreVO>>;
export default req;
